const ResetZoomButton = (props) => {

return (
    <div
        style={{
          transform:"translate(0,0)",
          cursor: props.resetButtonDisplay ? "pointer" : "default",
          position: "absolute",
          display: "block",
          color:"white",
          //height:tooltipHeight,
          left: 0,
          top: 0,
          background: "#12425e",
          //borderRadius: "0 0 10px 0",
          padding: 5,
          paddingTop:3,
          boxSizing:"border-box",
          zIndex:100
        }}
        onClick={props.resetButtonDisplay && props.resetPosition}
      >
        {props.resetButtonDisplay ?
        <p style={{margin:5, fontSize: "0.8em"}}><strong>Reset Zoom</strong></p>
      : <p style={{margin:5, fontSize: "0.8em"}}>Click a country to zoom</p>
      }
      </div>
)

}

export default ResetZoomButton